export default class TenantOptionHelper {
    static getBackgroundImage(context) {
        let result =  TenantOptionHelper.getOption(context, 'LOGIN_PAGE')
        if (result == '') return 'edc-background.jpg'
        return result
    }
    static getLoginLogo(context) {
        let result = TenantOptionHelper.getOption(context, 'LOGIN_LOGO')
        if (result == '') return TenantOptionHelper.getLogo(context)
        return result
    }

    static getLogo(context) {
        let result = TenantOptionHelper.getOption(context, 'LOGO')
        if (result == '') return 'edc-color.png'
        return result
    }

    static set(context, data) {
        context['domain_option'] = data.option
        context['tenant'] = data.tenantId
        jng.context.saveContext()
    }    

    static getOption(context, key) {
        let options = TenantOptionHelper.getOptions(context)
        for(let i = 0; i < options.length; i++) {
            const optionItem = options[i]
            if (optionItem.startsWith(key + '=')) {
                const optionItemParts = optionItem.split('=')
                if (optionItemParts.length < 2) return ''
                return optionItemParts[1]
            }
        }
        return ''
    }

    static getOptions(context) {
        let result = context['domain_option']
        if (result) {
            return result.split('|')
        }
        return []
    }
}